module.exports = __webpack_public_path__ + "img/ic-dash-farmresult.1c9cefb5.svg";